import { Toaster } from "react-hot-toast";
import "./ResponseMessage.scss";

const ResponseMessage = () => {
  return (
    <Toaster
      position="bottom-center"
      reverseOrder={true}
      toastOptions={{
        className: "toastItem",
      }}
    />
  );
};

export default ResponseMessage;
